import React, { useContext } from "react"
import { AppContext } from "../context/AppContext";
import stat from './../data/stat.json';
function Stat({unit,updateStat,forScreenshot}) {
    const getStat = () => {
        let levelTarget = unit.currentLevel;
        let targetStar = 6;
        if(levelTarget > 50 && levelTarget < 60){
            targetStar = 5;
        }
        if(levelTarget > 40 && levelTarget <= 50) {
            targetStar = 4;
        }
        if(levelTarget > 30 && levelTarget <= 40) {
            targetStar = 3;
        }
        if(levelTarget > 20 && levelTarget <= 30) {
            targetStar = 2;
        }
        if(levelTarget > 10 && levelTarget <= 20) {
            targetStar = 1;
        }
        if(levelTarget <= 10) {
            targetStar = 0;
        }
        
        let nbStar = unit.InitialStar;
        let id = unit.ID;
        let tabStat = stat.filter((s) => s.ID === id);
        let currentTab = tabStat.find((s) => s.Star === nbStar);
        let iLevel = currentTab.BaseLevel;
        let currentStat = {"atk":0,"hp": 0,"arm": 0,"spd":0};
        
        currentStat.atk = currentTab.BaseATK + currentTab.StarATK
        currentStat.hp = currentTab.BaseHP + currentTab.StarHP
        currentStat.arm = currentTab.BaseARM + currentTab.StarARM
        currentStat.spd = unit.SPEED + currentTab.StarSPEED
        while(iLevel !== levelTarget){
            if(levelTarget <= (nbStar * 10)) {
                for(let cpt = 1;cpt < 7;cpt++) {
                    currentTab = tabStat.find((s) => s.Star === (nbStar-cpt));
                    
                    for(let i = 1; i <= 10; i++) {
                        currentStat.atk -= currentTab.LvATK;
                        currentStat.hp -= currentTab.LvHP
                        currentStat.arm -= currentTab.LvARM
                        iLevel--;
                        if(iLevel === levelTarget) {
                            return currentStat;
                        }
                    }
                }
            } else {
                currentTab = tabStat.find((s) => s.Star === targetStar);
                iLevel = currentTab.BaseLevel;
                currentStat.atk = currentTab.BaseATK + currentTab.StarATK
                currentStat.hp = currentTab.BaseHP + currentTab.StarHP
                currentStat.arm = currentTab.BaseARM + currentTab.StarARM
                currentStat.spd = unit.SPEED + currentTab.StarSPEED
                if(iLevel === levelTarget) {
                    return currentStat;
                }

                for(let i = 1; i <= 10; i++) {
                    currentStat.atk += currentTab.LvATK;
                    currentStat.hp += currentTab.LvHP
                    currentStat.arm += currentTab.LvARM
                    if(iLevel === levelTarget) {
                        return currentStat;
                    }
                    iLevel++;
                }
            }
        }
        
        return currentStat;
        
    }
    const {searchKey} = useContext(AppContext);
    return (
        <div className={`stat grid md:grid-cols-2 ${forScreenshot ? 'grid-cols-2':'grid-cols-1'} gap-2 md:gap-1 xl:gap-2`}>
            {forScreenshot === false ? 
            <>
            <div className='mobile md:hidden grid grid-cols-1 gap-y-1'>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;ATK")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{Math.floor(getStat().atk)}</div>
                            <div className='basis-1/2'><input value={unit.bonusATK} onChange={(e) => updateStat(e,"bonusATK")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;HP")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{Math.floor(getStat().hp)}</div>
                            <div className='basis-1/2'><input value={unit.bonusHP} onChange={(e) => updateStat(e,"bonusHP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;ARM")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{Math.floor(getStat().arm)}</div>
                            <div className='basis-1/2'><input value={unit.bonusDEF} onChange={(e) => updateStat(e,"bonusDEF")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;SPEED")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{unit.SPEED}</div>
                            <div className='basis-1/2'><input value={unit.bonusSPEED} onChange={(e) => updateStat(e,"bonusSPEED")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;CRP")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{unit.CRP * 100} %</div>
                            <div className='basis-1/2'><input value={unit.bonusCRP} onChange={(e) => updateStat(e,"bonusCRP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;CRD")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{unit.CRD * 100} %</div>
                            <div className='basis-1/2'><input value={unit.bonusCRD} onChange={(e) => updateStat(e,"bonusCRD")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;ACC")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{unit.ACC * 100} %</div>
                            <div className='basis-1/2'><input value={unit.bonusACC} onChange={(e) => updateStat(e,"bonusACC")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
                    <div className='flex flex-col border-[#575e64] border rounded px-1'>
                        <div className='text-xs'>{searchKey("AttrsView;Name;RES")}</div>
                        <div className='flex flex-row justify-between'>
                            <div className='basis-1/2 font-bold'>{unit.RES * 100} %</div>
                            <div className='basis-1/2'><input value={unit.bonusRES} onChange={(e) => updateStat(e,"bonusRES")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                        </div>
                    </div>
            </div>
            <div className='md:flex flex-col hidden gap-y-1'>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;ATK")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().atk)}</div>
                        <div className='basis-1/2'><input value={unit.bonusATK} onChange={(e) => updateStat(e,"bonusATK")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;HP")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().hp)}</div>
                        <div className='basis-1/2'><input value={unit.bonusHP} onChange={(e) => updateStat(e,"bonusHP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;ARM")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().arm)}</div>
                        <div className='basis-1/2'><input value={unit.bonusDEF} onChange={(e) => updateStat(e,"bonusDEF")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;SPEED")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{unit.SPEED}</div>
                        <div className='basis-1/2'><input value={unit.bonusSPEED} onChange={(e) => updateStat(e,"bonusSPEED")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
            </div>
            <div className='md:flex flex-col hidden gap-1'>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;CRP")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.CRP * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusCRP} onChange={(e) => updateStat(e,"bonusCRP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;CRD")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.CRD * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusCRD} onChange={(e) => updateStat(e,"bonusCRD")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;ACC")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.ACC * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusACC} onChange={(e) => updateStat(e,"bonusACC")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;RES")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.RES * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusRES} onChange={(e) => updateStat(e,"bonusRES")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
            </div>
            </>
            :<>
            <div className='flex flex-col gap-y-1'>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;ATK")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().atk)}</div>
                        <div className='basis-1/2'><input value={unit.bonusATK} onChange={(e) => updateStat(e,"bonusATK")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;HP")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().hp)}</div>
                        <div className='basis-1/2'><input value={unit.bonusHP} onChange={(e) => updateStat(e,"bonusHP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;ARM")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{Math.floor(getStat().arm)}</div>
                        <div className='basis-1/2'><input value={unit.bonusDEF} onChange={(e) => updateStat(e,"bonusDEF")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='w-[30px] text-xs'>{searchKey("AttrsView;Name;SPEED")}</div>
                    <div className='flex flex-row gap-x-2'>
                        <div className='font-bold basis-1/2'>{unit.SPEED}</div>
                        <div className='basis-1/2'><input value={unit.bonusSPEED} onChange={(e) => updateStat(e,"bonusSPEED")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 6000" type="text"/></div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col gap-1'>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;CRP")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.CRP * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusCRP} onChange={(e) => updateStat(e,"bonusCRP")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;CRD")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.CRD * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusCRD} onChange={(e) => updateStat(e,"bonusCRD")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;ACC")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.ACC * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusACC} onChange={(e) => updateStat(e,"bonusACC")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
                <div className='flex flex-col border rounded border-[#575e64] pl-1'>
                    <div className='text-xs'>{searchKey("AttrsView;Name;RES")}</div>
                    <div className='flex flex-row gap-x-1 justify-between w-full'>
                        <div className='basis-1/2 font-bold'>{unit.RES * 100} %</div>
                        <div className='basis-1/2'><input value={unit.bonusRES} onChange={(e) => updateStat(e,"bonusRES")} className='w-full bg-[#171e26] text-[#8f79fa] font-bold' placeholder="+ 60 %" type="text"/></div>
                    </div>
                </div>
            </div>
            </>
            }
        </div>
    )
}
export default Stat;